var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.629 29.1196H31.1116C31.3492 29.1196 31.5787 29.0365 31.7608 28.885C32.0151 28.672 37.8175 23.6805 38.1713 12.9058H9.72947C9.37703 22.6864 4.03335 27.2835 3.97781 27.3294C3.65225 27.6045 3.53247 28.0538 3.67894 28.4536C3.82439 28.8524 4.20346 29.1196 4.629 29.1196ZM37.1918 6.82556H32.1249V5.81219C32.1249 5.24471 31.679 4.79883 31.1116 4.79883C30.5441 4.79883 30.0982 5.24471 30.0982 5.81219V6.82556H24.9638V5.81219C24.9638 5.24471 24.5179 4.79883 23.9504 4.79883C23.383 4.79883 22.9371 5.24471 22.9371 5.81219V6.82556H17.8702V5.81219C17.8702 5.24471 17.4244 4.79883 16.8569 4.79883C16.2894 4.79883 15.8435 5.24471 15.8435 5.81219V6.82556H10.7767C10.2092 6.82556 9.76332 7.27144 9.76332 7.83892V10.879H38.2051V7.83892C38.2051 7.27144 37.7592 6.82556 37.1918 6.82556Z",
    fill: "#0741AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0624 30.439C32.5122 30.8972 31.8215 31.1466 31.1119 31.1466H9.76367V34.1867C9.76367 34.7468 10.2169 35.2001 10.777 35.2001H37.1921C37.7522 35.2001 38.2055 34.7468 38.2055 34.1867V22.8271C36.2517 27.6204 33.5253 30.0516 33.0624 30.439Z",
    fill: "#0741AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.a2029023.svg";
export { ForwardRef as ReactComponent };